import instance from "@services/services";
import { AddValuesType, PackageMaster, PackageTableDataType } from "./types";
import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
const { MastersApi } = api;

export { getMastersTableData as getSubDepartment } from "../../ClinicMasters/SubDepartmentMasters/services";
export { getMastersTableData as cptSearch } from "../../ClinicMasters/cptMaster/services";
export { getMastersTableData as getCategories } from "../../ClinicMasters/CategoryMaster/services";
export { getMastersTableData as getSpeciality } from "../../GeneralMasters/SpecialityMaster/services";
export { getMastersTableData as getDrugs } from "../../GeneralMasters/DrugMaster/services";
export { getMastersTableData as getProcedure } from "../../ClinicMasters/cptMaster/services";
import { MasterTableDataType as ProcedureType } from "../../ClinicMasters/cptMaster/types";
import { MasterTableDataType as DrugType } from "../../GeneralMasters/DrugMaster/types";
import { SearchParamsType } from "../types";

export const savePackage = async (
  payload: PackageMaster
): Promise<ResponseType<string>> => {
  console.log(payload);
  try {
    const result = await instance.post(MastersApi.saveORUpdatePackage, payload);
    return result.data;
  } catch (e: any) {
    console.log(e)
    throw new Error(e.response?.data?.responseMessage || "Something went wrong !");
  }
};

// export const getPackages = async () => {
//   try {
//     const result = await instance.post(MastersApi.saveORUpdatePackage);
//     return result.data;
//   } catch (e: any) {
//     throw new Error(e.response?.data?.responseMessage || "Something went wrong !");
//   }
// };

export const getPackages = async (
  params: SearchParamsType
): Promise<ResponseType<{ totalCount: number; packageDto: PackageTableDataType[] }>> => {
  const result = await instance.post(
    `${MastersApi.getPackageList}`,
    params
  );
  return result.data;
};

export const getPackageDetails = async (payload: {
  clinicId: number;
  packageId: number;
}): Promise<
  ResponseType<{
    lab: AddValuesType[];
    radiology: AddValuesType[];
    prescription: DrugType[];
    procedure: ProcedureType[];
  }>
> => {
  try {
    const result = await instance.get(
      `${MastersApi.getPackageList}/${payload.clinicId}?packageId=${payload.packageId}`
    );
    return result.data;
  } catch (e: any) {
    throw new Error(e.response?.data?.responseMessage || "Something went wrong !");
  }
};
